export const SalesOrderStatusEnum = Object.freeze({
  PAID: "PAID",
  VOID: "VOID",
});

export const SalesOrderDeliveryStatusEnum = Object.freeze({
  PENDING: "PENDING",
  PARTIALLY_DELIVERED: "PARTIALLY_DELIVERED",
  FULLY_DELIVERED: "FULLY_DELIVERED",
});

export const SalesOrderInvoiceStatusEnum = Object.freeze({
  PENDING: "PENDING",
  PARTIALLY_INVOICED: "PARTIALLY_INVOICED",
  FULLY_INVOICED: "FULLY_INVOICED",
});
